{
  "language": {
    "title": "Escolha seu idioma",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Olá, como podemos ajudá-lo?",
    "checkIn": "Check-in",
    "independentManualCheckIn": "Sem agendamento",
    "integratedManualCheckIn": "Check-in manual",
    "checkOut": "Check-out",
    "manualCheckOut": "Check-out manual",
    "parcelDelivery": "Entrega de encomenda",
    "foodDelivery": "Entrega de comida",
    "callReception": "Ligar para recepção",
    "overview": "Visão geral",
    "unavailable": "A recepção está atualmente indisponível."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Escolha uma opção para fazer check-in",
        "manual": "Check-in manual",
        "code": "Check-in com código PIN ou QR",
        "code-no-qr": "Check-in com código PIN"
      },
      "checkout": {
        "title": "Escolha uma opção para fazer check-out",
        "manual": "Check-out com nome",
        "code": "Check-out com código PIN ou QR",
        "code-no-qr": "Check-out com código PIN"
      }
    },
    "title": "Agora você pode escanear seu código QR ou inserir seu código PIN.",
    "orText": "Ou",
    "qrScanner": {
      "checkin": {
        "title": "Escolha uma opção para fazer check-in"
      },
      "checkout": {
        "title": "Escolha uma opção para fazer check-out"
      },
      "btn": "Escaneie seu código QR"
    },
    "hidScanner": {
      "title": "Aproxime o código QR do scanner abaixo ou digite o seu código PIN"
    },
    "pinOnly": {
      "title": "Por favor, digite o seu código PIN"
    },
    "pinCode": "Digite seu código PIN",
    "manually": {
      "checkin": "Não tem código de check-in?"
    },
    "status": {
      "idle": {
        "title": "Seu código está sendo escaneado.",
        "message": "Por favor, aguarde...",
        "nfc": {
          "title": "Sua etiqueta está sendo escaneada.",
          "message": "Por favor, aguarde..."
        }
      },
      "loading": {
        "title": "Seu código está sendo escaneado.",
        "message": "Por favor, aguarde...",
        "nfc": {
          "title": "Sua etiqueta está sendo escaneada.",
          "message": "Por favor, aguarde..."
        }
      },
      "error": {
        "title": "Seu código é inválido.",
        "message": "Tente novamente!",
        "nfc": {
          "title": "Sua etiqueta é inválida.",
          "message": "Por favor, tente novamente!"
        },
        "meeting": {
          "tooEarly": {
            "title": "Você chegou um pouco cedo",
            "message": "Seu código é válido a partir das {{validFromTime}}. A reunião começa às {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Este código expirou",
            "message": "A reunião terminou às {{meetingEndTime}}. Seu código foi válido até {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Você fez check-in com sucesso.",
            "message": "Obrigado."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Você fez check-in com sucesso.",
              "message": "Obrigado."
            },
            "email-sms": {
              "title": "Você fez check-in com sucesso.",
              "message": "Sua pessoa de contato foi notificada."
            },
            "call-ping": {
              "title": "Você fez check-in com sucesso.",
              "message": "Agora estabeleceremos uma chamada telefônica com sua pessoa de contato."
            },
            "teams-call": {
              "title": "Você fez check-in com sucesso.",
              "message": "Agora estabeleceremos uma chamada do Microsoft Teams com sua pessoa de contato."
            },
            "badge": {
              "title": "Obrigado pelo check-in, seu crachá será impresso.",
              "message": ""
            },
            "video-call": {
              "title": "Você fez check-in com sucesso.",
              "message": "Configurando sua videochamada com a pessoa de contato."
            }
          },
          "Employee": {
            "title": "Você fez check-in com sucesso.",
            "message": "Obrigado.",
            "badge": {
              "title": "Obrigado pelo check-in, seu crachá será impresso.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Você fez check-in com sucesso.",
            "message": "Obrigado.",
            "badge": {
              "title": "Obrigado pelo check-in, seu crachá será impresso.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Você fez check-out com sucesso.<br/>",
            "message": "Até breve."
          },
          "MeetingAttendee": {
            "title": "Você fez check-out com sucesso.",
            "message": "Até breve."
          },
          "Employee": {
            "title": "Você fez check-out com sucesso.",
            "message": "Até breve."
          },
          "Visitor": {
            "title": "Você fez check-out com sucesso.",
            "message": "Até breve."
          },
          "access": {
            "title": "Você fez check-out com sucesso.",
            "message": "Agora você pode abrir a porta."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Mais alguns detalhes antes do check-in",
    "subtitle": "Os campos marcados com * são obrigatórios",
    "btn": "Fazer check-in",
    "placeholder": {
      "other": "Outro...",
      "otherInput": "Introduza a sua opção"
    },
    "error": {
      "required": "Não preencheu este campo",
      "email": "Endereço de e-mail inválido",
      "phone": "Número de telefone inválido"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Por favor, preencha.",
      "documentScanner": "Preste atenção ao inserir o seu documento de identidade:"
    },
    "subtitle": {
      "default": "Nota - cada campo * é obrigatório",
      "documentScanner": [
        {
          "parts": [
            { "text": "O ", "bold": false },
            { "text": "lado com os caracteres <<< >>> (MRZ) ", "bold": true },
            { "text": "deve estar ", "bold": false },
            { "text": "voltado para o quiosque / scanner.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Mantenha o cartão imóvel ", "bold": false },
            {
              "text": "até que os campos sejam preenchidos automaticamente.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Nenhuma opção",
    "btn": "Fazer check-in",
    "placeholder": {
      "name": "Seu nome *",
      "email": "Seu e-mail *",
      "phone": "Número de celular",
      "contactName": "Sua pessoa de contato*",
      "other": "Outro..."
    },
    "error": {
      "required": "Você não preencheu este campo",
      "name": "Nome inválido",
      "email": "Endereço de e-mail inválido",
      "phone": "Número de celular inválido"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Por favor, aguarde...",
          "message": "Seu registro está sendo processado."
        },
        "contact": {
          "title": "Por favor, aguarde...",
          "message": "Seu contato está sendo notificado."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Por favor, aguarde...",
          "message": "Seu registro está sendo processado."
        },
        "contact": {
          "title": "Por favor, aguarde...",
          "message": "Seu contato está sendo notificado."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Você fez check-in com sucesso.",
          "message": "Obrigado."
        },
        "email-sms": {
          "title": "Você fez check-in com sucesso.",
          "message": "Sua pessoa de contato foi notificada."
        },
        "call-ping": {
          "title": "Você fez check-in com sucesso.",
          "message": "Agora estabeleceremos uma chamada telefônica com sua pessoa de contato."
        },
        "teams-call": {
          "title": "Você fez check-in com sucesso.",
          "message": "Agora estabeleceremos uma chamada do Microsoft Teams com sua pessoa de contato"
        },
        "badge": {
          "title": "Obrigado pelo check-in, seu crachá será impresso.",
          "message": ""
        },
        "video-call": {
          "title": "Você fez check-in com sucesso.",
          "message": "Configurando sua videochamada com a pessoa de contato."
        }
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Tente novamente!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Documento inválido",
        "message": "O documento não pôde ser verificado ou expirou. Por favor, introduza os seus dados manualmente."
      }
    }
  },
  "manualCheckout": {
    "title": "Digite seu nome para fazer check-out",
    "btn": "Fazer check-out",
    "form": {
      "placeholder": {
        "name": "Seu nome completo *"
      },
      "loading": "Carregando...",
      "noOptions": "Nenhuma opção"
    },
    "error": {
      "required": "Você não preencheu este campo",
      "name": "Nome inválido"
    },
    "status": {
      "idle": {
        "title": "Estamos processando suas informações.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos processando suas informações.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "Você fez check-out com sucesso.",
        "message": "Obrigado e tenha um bom dia."
      },
      "successAccess": {
        "title": "Você fez check-out com sucesso.",
        "message": "Agora você pode abrir a porta."
      },
      "error": {
        "title": "Ocorreu um erro durante o check-out.",
        "message": "Tente novamente!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Gostaria de notificar sua pessoa de contato?",
      "email-sms": "Enviamos um e-mail/SMS para sua pessoa de contato.<br/>Deseja estabelecer uma chamada adicional com ela?"
    },
    "callBtn": "Ligar",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Chamada de vídeo",
    "teamsCallBtn": "Chamada Teams",
    "teamsMessageBtn": "Mensagem Teams",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Cancelar",
    "cancelBtn": "Cancelar chamada",
    "status": {
      "connecting": {
        "title": "Estabelecendo chamada.<br/>Por favor, aguarde...",
        "message": ""
      },
      "ringing": {
        "title": "Ligando para sua pessoa de contato<br/>Por favor, aguarde...",
        "message": ""
      },
      "ringingReception": {
        "title": "Chamada iniciada...",
        "message": ""
      },
      "open": {
        "title": "Chamada em andamento.",
        "message": ""
      },
      "close": {
        "title": "Chamada encerrada.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Chamada encerrada.<br/>Agora você pode abrir a porta.",
        "message": ""
      },
      "closeReception": {
        "title": "Chamada encerrada.",
        "message": ""
      },
      "error": {
        "title": "Chamada não foi estabelecida.<br/>Ligar novamente?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Estamos notificando sua pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos notificando sua pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "SMS foi enviado. O contato foi notificado.",
        "message": "Obrigado!"
      },
      "successAccess": {
        "title": "SMS foi enviado. O contato foi notificado.",
        "message": "Agora você pode abrir a porta."
      },
      "error": {
        "title": "SMS não foi enviado.",
        "message": "Tente novamente!"
      }
    }
  },
  "videoCall": {
    "title": "Chamada de vídeo",
    "endCall": "Encerrar chamada",
    "status": {
      "idle": {
        "title": "Estamos criando uma sala de vídeo.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos criando uma sala de vídeo.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "A sala de vídeo foi criada com sucesso.",
        "message": "Entrando na sala..."
      },
      "error": {
        "title": "A sala de vídeo não foi criada com sucesso.",
        "message": "Tente novamente!"
      }
    }
  },
  "teamsCall": {
    "title": "Chamada Teams",
    "controls": {
      "startCall": "Iniciar chamada",
      "endCall": "Sair",
      "camera": "Câmera",
      "cameraOff": "Câmera desligada",
      "mic": "Microfone",
      "micOff": "Microfone desligado",
      "ringing": "Tocando...",
      "noAnswer": "Ninguém atendeu a chamada."
    },
    "status": {
      "connecting": {
        "title": "Estabelecendo chamada.<br/>Por favor, aguarde...",
        "message": ""
      },
      "ringing": {
        "title": "Ligando para sua pessoa de contato<br/>Por favor, aguarde...",
        "message": ""
      },
      "connected": {
        "title": "Estabelecendo chamada",
        "message": ""
      },
      "disconnected": {
        "title": "Chamada encerrada.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Chamada encerrada.<br/>Agora você pode abrir a porta.",
        "message": ""
      },
      "error": {
        "title": "Chamada não foi estabelecida.<br/>Tente novamente",
        "message": ""
      },
      "noAnswer": {
        "title": "Ninguém atendeu a chamada.<br/>Tente novamente.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Estamos notificando sua pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos notificando sua pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "Mensagem foi enviada. O contato foi notificado.",
        "message": "Obrigado!"
      },
      "successAccess": {
        "title": "Mensagem foi enviada. O contato foi notificado.",
        "message": "Agora você pode abrir a porta."
      },
      "error": {
        "title": "Mensagem não foi enviada.",
        "message": "Tente novamente!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Estamos notificando sua pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos notificando sua pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "Mensagem foi enviada. O contato foi notificado.",
        "message": "Obrigado!"
      },
      "successAccess": {
        "title": "Mensagem foi enviada. O contato foi notificado.",
        "message": "Agora você pode abrir a porta."
      },
      "error": {
        "title": "Mensagem não foi enviada.",
        "message": "Tente novamente!"
      }
    }
  },
  "packageDelivery": {
    "title": "Que gentil da sua parte entregar uma encomenda!",
    "subtitle": "Selecione e notifique o destinatário",
    "subtitle1": "Pressione o botão abaixo para nos informar que você está aqui!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Para quem é a encomenda"
      },
      "error": {
        "contact": {
          "required": "Você não preencheu este campo"
        }
      }
    },
    "button": {
      "submit": "Notificar"
    },
    "status": {
      "loading": {
        "title": "Estamos notificando a pessoa de contato.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "no-email-sms": {
          "title": "Obrigado pela sua entrega!",
          "message": ""
        },
        "email-sms": {
          "title": "A pessoa de contato foi notificada.",
          "message": "Obrigado pela sua entrega!"
        },
        "call-ping": {
          "title": "Obrigado pela sua entrega!",
          "message": "Uma conexão telefônica será estabelecida com a pessoa de contato."
        },
        "teams-call": {
          "title": "Obrigado pela sua entrega!",
          "message": "Uma chamada do Microsoft Teams será feita para sua pessoa de contato."
        },
        "video-call": {
          "title": "Obrigado pela sua entrega!",
          "message": "Configurando sua videochamada com a pessoa de contato."
        }
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Tente novamente!"
      }
    }
  },
  "foodDelivery": {
    "title": "Que gentil da sua parte entregar comida!",
    "subtitle": "Selecione e notifique o destinatário",
    "subtitle1": "Pressione o botão abaixo para nos informar que você está aqui!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Para quem é a comida"
      },
      "error": {
        "contact": {
          "required": "Você não preencheu este campo"
        }
      }
    },
    "button": {
      "submit": "Notificar"
    },
    "status": {
      "loading": {
        "title": "Estamos notificando o contato.",
        "message": "Por favor, aguarde!"
      },
      "success": {
        "no-email-sms": {
          "title": "Obrigado pela sua entrega!",
          "message": ""
        },
        "email-sms": {
          "title": "O contato foi notificado.",
          "message": "Obrigado pela sua entrega!"
        },
        "call-ping": {
          "title": "Obrigado pela sua entrega!",
          "message": "Uma conexão telefônica será estabelecida com sua pessoa de contato."
        },
        "teams-call": {
          "title": "Obrigado pela sua entrega!",
          "message": "Uma chamada do Microsoft Teams será feita para sua pessoa de contato."
        },
        "video-call": {
          "title": "Obrigado pela sua entrega!",
          "message": "Configurando sua videochamada com a pessoa de contato."
        }
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Tente novamente!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Por favor, escaneie seu código QR",
    "subtitle": "Alinhe o código QR dentro dos cantos vermelhos e mantenha seu telefone estável.",
    "error": "Formato de código QR inválido",
    "unknownError": "Erro desconhecido ocorreu durante o escaneamento"
  },
  "common": {
    "backBtn": "Voltar"
  },
  "previewPDF": {
    "page": {
      "of": "de",
      "previous": "Anterior",
      "next": "Próxima"
    },
    "button": {
      "cancel": "Cancelar",
      "accept": "Aceitar",
      "next": "Próximo"
    },
    "title": {
      "consent": "Consentimento necessário"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "A recepção digital está offline no momento e não pode ser usada, a conexão com a internet deve ser verificada!",
    "check": "Você é um visitante e quer falar diretamente com um funcionário? Por favor, ligue para {{receptionistPhone}}"
  },
  "overview": {
    "title": "Digite o código para abrir a visão geral!",
    "noUsers": "Nenhum registro",
    "status": {
      "success": {
        "title": "O código é válido.",
        "message": ""
      },
      "error": {
        "title": "O código é inválido.",
        "message": "Tente novamente!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Por favor, aguarde...",
        "message": ""
      },
      "success": {
        "title": "Check-out bem-sucedido.",
        "message": ""
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Tente novamente!"
      }
    },
    "listTitle": "Lista de pessoas que fizeram check-in hoje mas não fizeram check-out",
    "page": "Página ",
    "table": {
      "head": {
        "fullName": "Nome",
        "type": "Tipo",
        "checkedinAt": "Check-in às",
        "host": "Anfitrião"
      },
      "type": {
        "Package": "Entrega de encomenda",
        "Food": "Entrega de comida",
        "Visitor": "Visitante",
        "MeetingAttendee": "Visitante convidado",
        "Employee": "Funcionário",
        "Guest": "Visitante"
      }
    },
    "confirmModal": {
      "title": "Tem certeza de que deseja fazer check-out de {{fullName}}?",
      "cancel": "Cancelar",
      "checkout": "Fazer check-out"
    }
  },
  "wifi": {
    "title": "Conectar à rede Wi-Fi"
  },
  "door": {
    "external": {
      "title": "Abrindo a porta",
      "subtitle": "A porta será aberta em breve. Por favor, aguarde..."
    },
    "control": {
      "title": "Agora você pode abrir a porta",
      "subtitle": "Por favor, pressione o botão abaixo!",
      "openBtn": "Abrir a porta"
    },
    "status": {
      "success": {
        "title": "A porta foi aberta",
        "message": ""
      },
      "error": {
        "title": "Algo deu errado",
        "message": "Entre em contato com sua pessoa de contato para abrir a porta."
      },
      "loading": {
        "title": "Abrindo a porta...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Gostaria de tirar uma foto como parte do seu processo de check-in?",
    "required": {
      "title": "Verificação por Foto Necessária!",
      "instructions": "Por favor, fique em frente à câmera e siga as instruções na tela.",
      "securityNotice": "Para fins de segurança e verificação, uma foto é necessária durante o check-in.",
      "privacyInfo": "Respeitamos sua privacidade. Seus dados são armazenados com segurança e usados apenas para identificação.",
      "closingMessage": "Obrigado pela sua cooperação."
    },
    "optional": {
      "title": "Gostaria de tirar uma foto como parte do seu processo de check-in?",
      "instructions": "",
      "securityNotice": "Tirar uma foto pode ajudar a agilizar a identificação e melhorar a segurança.",
      "privacyInfo": "Respeitamos sua privacidade. Este passo é opcional, e seus dados serão tratados com segurança.",
      "closingMessage": "Você pode pular este passo se preferir."
    },
    "subtitle": "Por favor, posicione-se dentro do quadro e permaneça imóvel para o melhor resultado",
    "button": {
      "cancel": "Cancelar",
      "accept": "Aceitar",
      "skip": "Pular",
      "next": "Próximo",
      "recapture": "Capturar foto novamente",
      "continue": "Continuar"
    },
    "error": "Ocorreu um erro ao capturar a foto. O processo de check-in continuará sem a foto."
  },
  "wayfinding": {
    "title": "Para onde gostaria de ir?"
  },
  "callingMenu": {
    "title": "Menu de chamadas"
  },
  "bell": {
    "status": {
      "success": {
        "title": "A campainha está tocando",
        "message": "Alguém virá em breve."
      },
      "error": {
        "title": "Algo correu mal",
        "message": "Tente novamente"
      },
      "loading": {
        "title": "A conectar...",
        "message": "Aguarde por favor"
      }
    }
  },
  "access": {
    "control": {
      "title": "Agora você pode abrir a porta",
      "subtitle": "Por favor, pressione o botão abaixo.",
      "titleAuto": "Acesso automático à porta",
      "subtitleAuto": "A porta será aberta automaticamente para você",
      "openBtn": "Abrir"
    },
    "status": {
      "success": {
        "title": "A porta foi aberta",
        "message": ""
      },
      "error": {
        "title": "Algo deu errado",
        "message": "Entre em contato com sua pessoa de contato para abrir a porta."
      },
      "loading": {
        "title": "Abrindo a porta...",
        "message": ""
      }
    }
  }
}
